<template>
  <div>
    <v-card v-if="template === 'cr_escalate'" class="app-card">
      <v-card-title class="d-block text-left">
        <h3 class="pb-2">{{ cr_escalate.resultmsg }}</h3>
      </v-card-title>
      <v-card-text class="black--text">
        <p><strong>Confirmation Number:</strong> #{{ cr_escalate.cr_id }}</p>
        <p><strong>Accepted Offer:</strong> {{ cr_escalate.offer_name }}</p>
        <br/>
        <h4>What's Next?</h4>
        <p>{{ cr_escalate.offer_message }}</p>
        <p>Email notifications are sent as your request is updated.</p>
      </v-card-text>
      <v-card-actions>
        <gg-btn color="primary" tile elevation="0"  :to="`/cancellations/${cr_escalate.cr_id}`">
          View Request
        </gg-btn>
        <gg-btn @click="redirectToDashboard" tile elevation="0"  color="gray">Return to Dashboard</gg-btn>
      </v-card-actions>
    </v-card>
    <v-card v-if="template === 'cr_open'" class="text-left">
      <v-card-title class="d-block">
        <h3>Cancellation Request Received</h3>
      </v-card-title>
      <v-card-text class="black--text">
        <p>Your cancellation request has been received and is pending processing. Please save
          your confirmation number for your records.</p>
        <p><strong>Confirmation Number:</strong> #{{ cr_open.id }}</p>
        <p><strong>You can re-enable auto-renewal any time before {{ formatRenewalDate(parseRenewalDate(cr_open.abort_by)) }}.</strong></p>
        <p>Email notifications are sent as your request is updated. </p>
        <p>Thank you for your patience.</p>
        <p>Did you make a mistake or change your mind? <a href='#' @click="autorenewConfirmModalOpen">Click here to enable auto-renewal.</a></p>
        <autorenew-enable
          v-if="autorenewConfirmModal"
          @close="autorenewCloseModal"
          :cr-id="cr_open.id"
          :go-to-route="`/cancellations/${cr_open.id}`"
        />
      </v-card-text>
      <v-card-actions>
        <gg-btn secondary @click="redirectToDashboard">Return to Dashboard</gg-btn>
        <gg-btn :to="`/cancellations/${cr_open.id}`">
          View Request
        </gg-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { cancellationTypes } from '@/consts/cancellations'
import AutorenewEnable from 'Components/Modals/AutorenewEnable'
import {
  parseRenewalDate,
  formatRenewalDate,
} from 'Helpers/helpers'

export default {
  name: 'CancelConfirmation',
  components: {
    AutorenewEnable,
  },
  props: {
    template: {
      type: String,
      required: true,
      default: ''
    },
    cr_escalate: {
      type: Object,
      required: true,
      default: () => ({})
    },
    cr_open: {
      type: Object,
      required: true,
      default: () => ({})
    },
  },
  data () {
    return {
      cancellationTypes,
      autorenewModalConfirmOpen: false,
      autorenewLoading: false,
      autorenewConfirmModal: false,
    }
  },
  computed: {
    serviceId () {
      return this.$route.params.service_id
    },
    serviceType () {
      return this.$route.query.type
    }
  },
  methods: {
    ...mapActions({
      enableAutorenew: 'enableAutorenew',
    }),
    redirectToDashboard () {
      this.$router.push({ name: 'dashboard' })
    },
    openModalAutorenew () {
      this.autorenewModalConfirmOpen = true
    },
    closeModalAutorenewConfirm () {
      this.autorenewModalConfirmOpen = false
    },
    async acceptModalAutorenewConfirm () {
      if (!this.serviceId || !this.serviceType) {
        console.error('Auto-renew failed due to missing parameters:', { serviceId: this.serviceId, serviceType: this.serviceType })
        return
      }

      this.autorenewLoading = true
      try {
        await this.callEnableAutorenew()
      } finally {
        this.autorenewLoading = false
        this.closeModalAutorenewConfirm()
      }
    },
    async callEnableAutorenew () {
      if (!this.serviceId || !this.serviceType) {
        console.error('Auto-renew failed due to missing parameters:', { serviceId: this.serviceId, serviceType: this.serviceType })
        return
      }

      if (!this.cr_open.id) {
        console.error('Missing cancellation_id (cr_open.id)')
        return
      }
      try {
        await this.enableAutorenew({ service_id: this.serviceId, service_type: this.serviceType, cancellation_id: this.cr_open.id })
        this.$router.push({ path: `/cancellations/${this.cr_open.id}` })
      } catch (error) {
        console.error(`Error enabling auto-renew for service ${this.serviceId} (type: ${this.serviceType}):`, error)
      }
    },
    autorenewConfirmModalOpen () {
      this.autorenewConfirmModal = true
    },
    async autorenewCloseModal () {
      await this.getData()
      this.autorenewConfirmModal = false
    },
    parseRenewalDate,
    formatRenewalDate,
  }
}
</script>
